export const API_URL = {
  SEARCH_API: "chat",
  FEED_BACK_API: "feedback",
  DATA_SYNC_API: "datasync",
  EXISTING_KEYS_API :"ExistingKeys",
  QUESTIONNAIRE_API :"Questionnaire",

};
